import { jsx } from 'react/jsx-runtime';

const MinusIcon = ({
  size,
  color = "currentColor"
}) => {
  return /*#__PURE__*/jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.039 14.039",
    style: {
      width: `${size.toString()}px`,
      height: `${size.toString()}px`
    },
    fill: color,
    children: /*#__PURE__*/jsx("path", {
      d: "M0 7c0 .5.4.9.9.9h12.2c.5 0 .9-.4.9-.9s-.4-.9-.9-.9H.9c-.5 0-.9.4-.9.9z"
    })
  });
};

export { MinusIcon };
//# sourceMappingURL=MinusIcon.js.map
